import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { HouseClaimsPage } from '@/features/houses/claims/house-claims-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/houses/claims'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: HouseClaimsPage,
})
